import { render, staticRenderFns } from "./MergeContact.vue?vue&type=template&id=6cc0242a"
import script from "./MergeContact.vue?vue&type=script&lang=js"
export * from "./MergeContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports